module.exports = __webpack_public_path__ + "media/corporate-image/gear-naname2-226553e8d8cd53a9077c829ad97cef32.png";